import React, { useEffect, useRef, useState } from "react";

import { _common } from "../common";
import { ServerInterface } from "../ServerInterface";
const common = _common;

export default function HotNews() {
  const refOuter = useRef<HTMLDivElement>(null);
  const refInner = useRef<HTMLDivElement>(null);

  const [hotNewsText, setHotNewsText] = useState("");

  function hashCode(text: string): number {
    var hash = 0;
    if (text.length == 0) {
      return hash;
    }
    for (var i = 0; i < text.length; i++) {
      var char = text.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
  }

  useEffect(() => {
    ServerInterface.getHotNews().then((txt) => {
      if (txt) {
        setHotNewsText(txt);
      }
    });
  }, []);

  useEffect(() => {
    //
    // autohide hotNews if Unchanged
    //
    var hc = hashCode($("#htmlHotNews").text()).toString();
    var hashCodeLast = localStorage?.getItem("hotNewsHash");
    if (hc == hashCodeLast) {
      ///// show hotnews allway ....  $("#htmlHotNews").hide();
    }

    setTimeout(() => {
      if (refOuter.current && refInner.current) {
        const hOuter = refOuter.current.clientHeight;
        const hInner = refInner.current.clientHeight;

        if (hInner > hOuter) {
          setTimeout(() => {
            if (refInner.current) {
              refInner.current.style.marginTop = `0px`;
            }
          }, 15000);

          refInner.current.style.marginTop = `-${hInner - hOuter}px`;

          refInner.current.style.transition = "all 15s";
        }
      }
    }, 50);

    // margin-top: -300px;
  });

  function hideHotnews() {
    var hc = hashCode($("#htmlHotNews").text());
    localStorage?.setItem("hotNewsHash", hc.toString());

    $("#htmlHotNews").hide();
  }

  const id = `${common.anzeigeTafelMode ? "htmlHotNewsDisplay" : "htmlHotNews"}`;

  return (
    <div id={id} ref={refOuter}>
      <style>{`
        #htmlHotNewsDisplay p {
          font-size: 0.8em
        }
        #htmlHotNewsDisplay h1 {
          font-size: 1em
        }
        #htmlHotNewsDisplay h2 {
          font-size: 1em
        }
      `}</style>
      <div
        ref={refInner}
        style={{
          padding: "20px",
          backgroundColor: common.anzeigeTafelMode ? "white" : "orange",

          textAlign: "left",
        }}
        className="container"
      >
        <div id="htmlHotNewsContent" dangerouslySetInnerHTML={{ __html: hotNewsText }}></div>

        {false && !common.anzeigeTafelMode && (
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "end" }}>
            <button
              id="btnHideHotNews"
              type="button"
              style={{
                background: "wheat",
                width: "max-content",
              }}
              className="btn"
              onClick={() => hideHotnews()}
            >
              <b> Ok, </b>
              habe ich gelesen. Bitte ausblenden
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
